// extracted by mini-css-extract-plugin
export var centerList = "_ix-6";
export var centerLoc = "_ix-a";
export var centerName = "_ix-9";
export var centerOptionBody = "_ix-8";
export var centerRow = "_ix-7";
export var centerStatus = "_ix-b";
export var empty = "_ix-5";
export var externalIcon = "_ix-c";
export var fieldHeader = "_ix-2";
export var fieldHelp = "_ix-4";
export var fieldLabel = "_ix-3";
export var panel = "_ix-0";
export var removeBtn = "_ix-d";
export var section = "_ix-1";